// extracted by mini-css-extract-plugin
export default {"personVerification":"person-verification_personVerification__EesUy"};